const PPCP_PAYMENT_SOURCES = ['venmo', 'paypal', 'card']
const DEFAULT_PAYMENT_SOURCE = 'paypal'

const FUNDING_SOURCE_ALIASES = {
  paylater: 'card',
  credit: 'card',
}

function normalizeFundingSource(value) {
  if (value == null) return undefined

  if (typeof value === 'string') {
    return value.toLowerCase()
  }

  if (typeof value === 'object' && !Array.isArray(value)) {
    const key = Object.keys(value)[0]
    return key ? key.toLowerCase() : undefined
  }

  return undefined
}

function toPpcpPaymentSource(fundingSource) {
  if (fundingSource == null) return DEFAULT_PAYMENT_SOURCE

  const normalized = FUNDING_SOURCE_ALIASES[fundingSource] ?? fundingSource
  if (PPCP_PAYMENT_SOURCES.includes(normalized)) return normalized

  return DEFAULT_PAYMENT_SOURCE
}

/**
 * PayPal funding source from SDK callbacks (e.g. "card", "venmo").
 * Checks createOrder data, onClick data, or a raw string.
 */
export function ppcpPaymentSourceFromPaypal(source) {
  if (typeof source === 'string') {
    return toPpcpPaymentSource(normalizeFundingSource(source))
  }

  if (source == null) return DEFAULT_PAYMENT_SOURCE

  const raw = source.paymentSource ?? source.payment_source ?? source.fundingSource
  return toPpcpPaymentSource(normalizeFundingSource(raw))
}
